import './Heading08.scss';
import clsx from 'clsx';
import React, { ComponentPropsWithoutRef, ElementType, PropsWithChildren } from 'react';

type PolymorphicProps<E extends ElementType> = PropsWithChildren<ComponentPropsWithoutRef<E> & {
  as?: E;
}>;

type Props <T extends React.ElementType> = PolymorphicProps<T> & PropsWithChildren<{
  className?: string;
}>;

export const Heading08 = <T extends ElementType = 'p'>(
  { className, as, children, ...props }: Props<T>,
): React.ReactElement => {
  const Component = as || 'p';

  return (
    <Component className={clsx('bp-heading-08', className)} {...props}>
      {children}
    </Component>
  );
};
